/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from 'react';
import { ILazyImagePlaceholderStyles, Internal__LazyImagePlaceholder } from './placeholder';
import { ILazyImageFrameStyles, Internal__LazyImageFrame } from './frame';
import { IStyle, mergeStyles } from '@fluentui/react';
import { internal__getLazyImageStyles } from './styles';
import { BwjViewState } from '../bwj-view-manager';

export interface ILazyImageStyles {
  root?: IStyle;
  imageFrame?: ILazyImageFrameStyles;
  untouchedFrame?: ILazyImagePlaceholderStyles;
  errorFrame?: ILazyImagePlaceholderStyles;
  loadingFrame?: ILazyImagePlaceholderStyles;
}

export interface ILazyImageProps {
  src: string;
  alt?: string | undefined;
  loadImage: boolean | null | undefined;
  onImageLoaded?: (src: string) => void;
  onLoadError?: (src: string) => void;
  styles?: ILazyImageStyles
}

export const BwjLazyImage: React.FunctionComponent<ILazyImageProps> = (props) => {
  const [viewState, setViewState] = useState(BwjViewState.Untouched);
  const { loadImage } = props;

  const styles = internal__getLazyImageStyles();
  const rootStyle = !!props.styles?.root ? mergeStyles([styles.root, props.styles.root])  : mergeStyles([styles.root]);

  useEffect(() => {
    // when triggered to load the image, show loading state
    if(loadImage === true) {
      setViewState(BwjViewState.Loading);
    }
  }, [loadImage]);
  const src = props.loadImage === true ? props.src : undefined;

  const onImageLoaded = (src: string) => {
    setViewState(BwjViewState.Ready);
    !!props.onImageLoaded && props.onImageLoaded(src);
  };

  const onLoadError = (src: string) => {
    setViewState(BwjViewState.Error);
    !!props.onLoadError && props.onLoadError(src);
  };

  return (
    <div className={rootStyle}>
        {viewState === BwjViewState.Untouched && <Internal__LazyImagePlaceholder icon='PictureFill' styles={props.styles?.untouchedFrame} />}
        {viewState === BwjViewState.Error && <Internal__LazyImagePlaceholder icon='Error' styles={props.styles?.errorFrame} />}
        {viewState === BwjViewState.Loading && <Internal__LazyImagePlaceholder icon='spinner' styles={props.styles?.loadingFrame} />}
        <Internal__LazyImageFrame
          src={src}
          alt={props.alt}
          onImageLoaded={onImageLoaded}
          onLoadError={onLoadError}
          styles={props.styles?.imageFrame}
        />
    </div>
  );
};
